import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PERMISSIONS, landingRoute } from '@/constants/permissions';
import { ROUTES } from '@/constants/routes';
import { AppLayout } from '@/layouts';
import { NotFound } from '@/shared/NotFound';
import { useAuthStore } from '@/stores/authStore';
import { ProtectedRoute } from './ProtectedRoute';

const Login = lazy(() => import('@/features/auth'));
const SetPassword = lazy(() => import('@/features/setPassword'));
const Sites = lazy(() => import('@/features/sites'));
const Billing = lazy(() => import('@/features/billing'));
const Transactions = lazy(() => import('@/features/transactions'));
const Disbursement = lazy(() => import('@/features/disbursement'));
const Administrators = lazy(() => import('@/features/administrators'));

function Loading() {
  return (
    <div className="flex h-screen items-center justify-center">
      <p className="text-gray-500">Loading...</p>
    </div>
  );
}

function LoginRoute() {
  const admin = useAuthStore((state) => state.admin);
  return admin ? <Navigate to={landingRoute(admin)} replace /> : <Login />;
}

function HomeRoute() {
  const admin = useAuthStore((state) => state.admin);
  return <Navigate to={landingRoute(admin)} replace />;
}

export function AppRoutes() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path={ROUTES.login} element={<LoginRoute />} />
        <Route path={ROUTES.setPassword} element={<SetPassword />} />

        <Route element={<AppLayout />}>
          <Route
            path={ROUTES.sites}
            element={
              <ProtectedRoute permission={PERMISSIONS.sitesView}>
                <Sites />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.billing}
            element={
              <ProtectedRoute permission={PERMISSIONS.billingView}>
                <Billing />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.transactions}
            element={
              <ProtectedRoute permission={PERMISSIONS.transactionsView}>
                <Transactions />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.disbursement}
            element={
              <ProtectedRoute permission={PERMISSIONS.disbursementView}>
                <Disbursement />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.administrators}
            element={
              <ProtectedRoute permission={PERMISSIONS.administratorsView}>
                <Administrators />
              </ProtectedRoute>
            }
          />
        </Route>

        <Route path={ROUTES.home} element={<HomeRoute />} />
        <Route path={ROUTES.notFound} element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}
